import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Icon5 from "../../assest/images/Icon5.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';

const RMEdit = () => {
  const { id } = useParams();
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);


  const navigate = useNavigate();

  const [routeDetails, setRouteDetails] = useState({
    RUTL_Name: '',
    RUTL_Status: '',
  });

  const [scpNamesForSelect, setScpNamesForSelect] = useState([]);
  const [scpName, setScpName] = useState('');
  const [routeNameError, setRouteNameError] = useState('');
  const [statusError, setStatusError] = useState('');
  const [scpNameError, setScpNameError] = useState('');
  const [scpNamesList, setScpNamesList] = useState([]);
  const [fetchedScpIds, setFetchedScpIds] = useState([]);
  const [suspendConfirmationModal, setSuspendConfirmationModal] = useState(false);
  const [deletedSCPId, setDeletedSCPId] = useState(null);
  const [deletedSCPName, setDeletedSCPName] = useState('');
  const [initialRouteDetails, setInitialRouteDetails] = useState(null);
  const [initialScpNamesList, setInitialScpNamesList] = useState(null);
  const [loading, setLoading] = useState(false);
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };
  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);


  useEffect(() => {
    fetch(`${config.API_URL}/routing_master/list/showdetail/${id}`)
      .then(response => response.json())
      .then(data => {
        if (data.details) {
          console.log("Fetched status:", data.details.RUTL_Status);
          const fetchedDetails = {
            RUTL_Name: data.details.RUTL_Name,
            RUTL_Status: data.details.RUTL_Status,
          };
          setRouteDetails(fetchedDetails);
          if (!initialRouteDetails) {
            setInitialRouteDetails(fetchedDetails); // Set initial values only once
          }
          logAction(`Accessed RouteMaster Edit Page for Route ${id} (${data.details.RUTL_Name})`);
        } else {
          console.error('Error: Route details not found.');
        }
      })
      .catch(error => {
        console.error('Error fetching Route details:', error);
        logAction(`Error fetching Route details for Route ${id}: ${error.message}`, true);
      });

    fetchScpNamesForSelect(selectedScpId);

    fetch(`${config.API_URL}/routing_master/${id}`)
      .then(response => response.json())
      .then(data => {
        if (data && data.length > 0) {
          const scpNames = data.map(item => ({
            id: item.RUTM_SCPID,
            name: item.SCPM_Name
          }));
          console.log("SCP Names for List fetched:", scpNames);
          setScpNamesList(scpNames);

          if (!initialScpNamesList) {
            setInitialScpNamesList(scpNames); // Set initial values only once
          }
          logAction("SCP Names fetched successfully");
        } else {
          console.error('No SCP Names found for this route ID.');
        }
      })
      .catch(error => {
        console.error('Error fetching SCP Names for List:', error);
        logAction(`Error fetching SCP Names for List for Route ${id}: ${error.message}`, true);
      });
  }, [id, selectedScpId]);

  const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 13,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const fetchScpNamesForSelect = (scpId) => {
    logAction('fetchScpNamesForSelect():started');
    fetch(`${config.API_URL}/routing_master/scpcode/${scpId}`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log('SCP data for Select fetched successfully:', data.scpData);
          setScpNamesForSelect(
            data.scpData.map(scp => ({
              label: scp.name,
              value: scp.id
            }))
          );
        } else {
          console.error('Failed to fetch SCP Names for Select:', data.message);
        }
      })
      .catch(error => {
        console.error('Error fetching SCP Names for Select:', error);
        logAction(`fetchScpNamesForSelect():Error fetching SCP Names for Select for Route ${scpId}: ${error.message}`, true);
      })
      .finally(() => {
        logAction('fetchScpNamesForSelect():ended');
      });
  };

  const validateRouteName = (input) => {
    logAction('validateRouteName():started');

    if (!input || input.trim() === '') {
      setRouteNameError('');
      logAction('validateRouteName():ended');
      return;
    }

    if (input.length > 50) {
      setRouteNameError('Route name must be 50 characters or less');
      logAction(
        `validateRouteName():Validation Error: Route Name exceeds 50 characters: ${input}`,
        true
      );
      return;
    }

    // Allowed characters
    if (!/^[A-Za-z0-9\-_. ]+$/.test(input)) {
      setRouteNameError('Please use only special characters like -, _, . and space');
      logAction(
        `validateRouteName():Validation Error: Invalid characters in Route Name: ${input}`,
        true
      );
      return;
    }

    // First & last must be alphanumeric (ignore single char case)
    if (
      input.length > 1 &&
      (!/^[A-Za-z0-9]/.test(input) || !/[A-Za-z0-9]$/.test(input))
    ) {
      setRouteNameError('First and last characters must be alphanumeric');
      logAction(
        `validateRouteName():Validation Error: First/Last not alphanumeric: ${input}`,
        true
      );
      return;
    }

    // No consecutive special characters
    if (/[\-_. ]{2,}/.test(input)) {
      setRouteNameError('Consecutive special characters are not allowed');
      logAction(
        `validateRouteName():Validation Error: Consecutive special characters: ${input}`,
        true
      );
      return;
    }

    // ✅ Valid
    setRouteNameError('');
    logAction('validateRouteName():ended');
  };



  const handleInputChange = (e) => {
    logAction('handleInputChange():started');

    const { name, value } = e.target;
    let updatedValue = value;

    // Enforce max length while typing for Route Name
    if (name === 'RUTL_Name' && value.length > 50) {
      updatedValue = value.slice(0, 50);
    }

    setRouteDetails(prev => ({
      ...prev,
      [name]: updatedValue
    }));

    if (name === 'RUTL_Name') {
      validateRouteName(updatedValue);
    }

    if (name === 'RUTL_Status') {
      validateStatus(updatedValue);
    }

    logAction('handleInputChange():ended');
  };


  const validateStatus = (input) => {
    logAction('validateStatus():started');
    if (input === '' || input === 'Select Status') {
      setStatusError('Please select a valid status.');
      logAction(`validateStatus():Validation Error: Invalid Status selected: ${input}`, true);
    } else {
      setStatusError('');
    }
    logAction('validateStatus():ended');
  };

  const handleEdit = async () => {
    setLoading(true); // ✅ START LOADING
    logAction(`handleEdit():Initiated Route Edit for Route ${id}`);

    // Validate Route Name
    if (!routeDetails.RUTL_Name || routeNameError) {
      setStatusError('');
      setScpNameError('');
      setRouteNameError('Route Name is required or invalid.');
      logAction(`handleEdit():Validation Error: Route Name is required or invalid: ${routeDetails.RUTL_Name}`, true);
      setLoading(false); // ✅ STOP LOADING
      return;
    }

    // Validate Status
    if (!routeDetails.RUTL_Status || statusError) {
      setRouteNameError('');
      setScpNameError('');
      setStatusError('Status is required or invalid.');
      logAction(`handleEdit():Validation Error: Status is required or invalid: ${routeDetails.RUTL_Status}`, true);
      setLoading(false); // ✅ STOP LOADING
      return;
    }

    // Ensure SCP Name is set
    if (!scpNamesList.length) {
      setRouteNameError('');
      setStatusError('');
      showToast('error', `At least one SCP is required to save the Route.`);
      //setScpNameError('Please add at least one SCP Name.');
      logAction('handleEdit():Validation Error: No SCP Name added.', true);
      setLoading(false); // ✅ STOP LOADING
      return;
    }

    // Prevent inactivation if linked
    if (parseInt(initialRouteDetails.RUTL_Status) === 1 && parseInt(routeDetails.RUTL_Status) !== 1) {
      try {
        const response = await fetch(`${config.API_URL}/routestatus/${id}`);
        const result = await response.json();

        console.log("result.activeUserCount", result.activeUserCount);

        if (response.status === 200 && result.activeUserCount > 0) {
          showToast('error', `You cannot inactivate the Route : ${routeDetails.RUTL_Name} because a reference exists in the Shipment Master.`);
          setLoading(false); // ✅ STOP LOADING
          return;
        } else if (response.status === 200 && result.activeSchemeCount > 0) {
          showToast('error', `You cannot inactivate the Route : ${routeDetails.RUTL_Name} because a reference exists in the Scheme Master.`);
          setLoading(false); // ✅ STOP LOADING
          return;
        }
        else if (response.status === 404) {
          setLoading(false); // ✅ STOP LOADING
          return;
        }

      } catch (error) {
        console.error('Error fetching group status:', error);
        setLoading(false); // ✅ STOP LOADING
        return;
      }
    }

    // Extract SCP names & IDs
    const currentScpNames = scpNamesList.map(scp => scp.name);
    const allScpNames = fetchedScpIds ? [...currentScpNames, ...fetchedScpIds] : currentScpNames;

    const currentScpIds = scpNamesList.map(scp => scp.id);
    const allScpIds = fetchedScpIds ? [...currentScpIds, ...fetchedScpIds] : currentScpIds;

    const data = {
      RUTL_Name: routeDetails.RUTL_Name,
      RUTL_Status: routeDetails.RUTL_Status,
      RUTL_ModifiedBy: UM_UserId,
      RUTM_SCPID: allScpIds,
    };

    console.log("Data", data);

    const initialRouteStatus = parseInt(initialRouteDetails.RUTL_Status) === 1 ? 'Active' : 'Inactive';
    const currentRouteStatus = parseInt(routeDetails.RUTL_Status) === 1 ? 'Active' : 'Inactive';

    const transactionDetails = [
      {
        AUTRN_ParamererName: "Route Name",
        AUTRN_OldValue: initialRouteDetails.RUTL_Name,
        AUTRN_NewValue: routeDetails.RUTL_Name
      },
      {
        AUTRN_ParamererName: "Status",
        AUTRN_OldValue: initialRouteStatus,
        AUTRN_NewValue: currentRouteStatus
      },
      {
        AUTRN_ParamererName: "Route Details",
        AUTRN_OldValue: JSON.stringify(
          initialScpNamesList.map((row, index) => ({
            "Sr. No.": index + 1,
            "SCP Name": row.name
          }))
        ),
        AUTRN_NewValue: JSON.stringify(
          scpNamesList.map((row, index) => ({
            "Sr. No.": index + 1,
            "SCP Name": row.name
          }))
        )
      }
    ];

    try {
      const response = await fetch(`${config.API_URL}/routing_master/list/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status} ${response.statusText}`);
      }

      const result = await response.text();
      console.log(result);

      logAction(`handleEdit():Edited Route ${id} (${routeDetails.RUTL_Name}) successfully`);

      logAudit(
        'Route Master',
        `Route : ${routeDetails.RUTL_Name} is updated successfully`,
        '-',
        '-',
        transactionDetails
      );

      toast.success(`Route : ${routeDetails.RUTL_Name} updated successfully.`, {
        onClose: () => {
          navigate(`/dashboard/rm`);
          handleReset();
        }
      });

    } catch (error) {
      console.error('Error updating route details:', error.message);
      logAction(`handleEdit():Error updating Route ${id}: ${error.message}`, true);
    } finally {
      //setLoading(false); // ✅ STOP LOADING ALWAYS
      logAction('handleEdit():ended');
    }
  };
  const handleOpenModal = (scpId, scpName) => {
    setDeletedSCPId(scpId);
    setDeletedSCPName(scpName);
    setSuspendConfirmationModal(true);
  };

  const handleCloseModal = () => {
    setSuspendConfirmationModal(false);
    setDeletedSCPId(null);
    setDeletedSCPName('');
  };

  const confirmRemoveSCP = () => {
    if (deletedSCPId !== null) {
      removeSCP(deletedSCPId);
    }
    handleCloseModal();
  };

  const removeSCP = (scpId) => {
    logAction('removeSCP():started');
    const updatedScpList = scpNamesList.filter(scp => scp.id !== scpId);
    setScpNamesList(updatedScpList);
    logAction(`removeSCP():Removed SCP ID ${scpId} from Route ${id}`);
    logAction('removeSCP():ended');
  };

  const addSCPToList = () => {
    logAction('addSCPToList(): started');
    console.log("ScpNamesList", scpNamesList)
    // Check if SCP Name (ID) is empty
    if (!scpName) {
      setScpNameError('SCP Name is required.');
      logAction('addSCPToList(): SCP Name is required.', true);
      return;
    }

    // Check if the SCP ID already exists in the list
    if (scpNamesList.some(scp => scp.id === scpName)) {
      const existingName = scpNamesList.find(scp => scp.id === scpName)?.name || scpName;
      showToast('error', `SCP Name: ${existingName} is already added.`);
      logAction(`addSCPToList(): Found same SCP ID ${scpName} already in the SCP table`, true);
      return;
    }

    // Find SCP name using the ID
    const selectedSCP = scpNamesForSelect.find(option => option.value === scpName);
    if (!selectedSCP) {
      //toast.error('Invalid SCP selection.');
      logAction(`addSCPToList(): SCP ID ${scpName} not found in options.`, true);
      return;
    }

    // Add the new SCP to the list
    const newSCP = { id: selectedSCP.value, name: selectedSCP.label };
    console.log("newSCP", newSCP);
    setScpNamesList([...scpNamesList, newSCP]);
    setScpName('');
    setScpNameError('');
    console.log("Updated scpNamesList", scpNamesList)
    logAction(`addSCPToList(): Added SCP Name ${selectedSCP.label} to Route ${id}`);
    logAction('addSCPToList(): ended');
  };



  const handleReset = () => {
    logAction('handleReset():started');
    setScpNamesList([]);
    setScpName('');
    setRouteNameError('');
    setStatusError('');
    setScpNameError('');
    setRouteDetails(prev => ({
      ...prev,
      RUTL_Status: 1
    }));
    // Log action when Reset button is clicked
    logAction(`handleReset():Reset Route Edit form for Route ${id}`);
    logAction('handleReset():ended');
  };

  // Function to log actions
  const logAction = (message, isError = false) => {

    fetch(`${config.API_URL}/api/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        module: "Route-Master:",
        action: message,
        userCode: UM_UserCode,
        isError: isError,
      }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Server error: ${response.status} ${response.statusText}`);
        }
        return response.text();
      })
      .then(result => {
        console.log(result);
      })
      .catch(error => {
        console.error('Error logging action:', error.message);
      });
  };

  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };
  return (

    <>
      {loading && (
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          zIndex: 1000
        }} />
      )}
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />

      <div className='main_container'>
        <h2 className='formHeading'>Route Master</h2>

        <div className='row'>
          {/* <div className='form-section'> */}
          <div className="col-md-6">
            <div className='mb-3'>
              <label>Route Name</label>
              <input
                type="text"
                className={`input-fields ${routeNameError ? 'input-error' : ''}  form-input`}
                name="RUTL_Name"
                value={routeDetails.RUTL_Name}
                onChange={handleInputChange}
                disabled
              />
              {routeNameError && <span className="error-message">{routeNameError}</span>}
            </div>
          </div>

          <div className="col-md-6">
            <label>Status</label>
            <div className='select-container'>
              <Select
                className="routing_select-box"
                options={[
                  { value: 1, label: 'Active' },
                  { value: 2, label: 'Inactive' },
                ]}
                value={
                  [
                    { value: 1, label: 'Active' },
                    { value: 2, label: 'Inactive' },
                  ].find(opt => opt.value === routeDetails.RUTL_Status) || null
                }
                onChange={(option) => {
                  handleInputChange({
                    target: {
                      name: 'RUTL_Status',
                      value: option ? option.value : ''
                    }
                  });
                }}
                onMenuOpen={() => handleSelectOpen('RUTL_Status')}
                onMenuClose={handleSelectClose}
                maxMenuHeight={140}
                isSearchable={false}
              />

              <div className="icon-container_list myList">
                <i>
                  {isSelectOpen === 'RUTL_Status' ? (
                    <IoCaretUpOutline />
                  ) : (
                    <IoCaretDownOutline />
                  )}
                </i>
              </div>
            </div>
            {statusError && <span className="error-message">{statusError}</span>}
          </div>

          <div className="col-md-6 mb-3">
            <label className="label-input-value">SCP Name{scpNameError && <span style={{ color: 'red' }}> *</span>}</label>
            <div className='select-container'>
              <Select
                className={`input-fields ${scpNameError ? 'input-error' : ''} routing_select-box`}
                options={scpNamesForSelect.map(option => ({
                  ...option,
                  isDisabled: scpNamesList.some(scp => scp.id === option.value)
                }))}
                value={scpNamesForSelect.find(opt => opt.value === scpName) || null}
                onChange={(selectedOption) => {
                  const value = selectedOption?.value;
                  setScpName(value);

                  // ✅ Clear SCP error when selected
                  if (value) {
                    setScpNameError('');
                  }
                }}
                placeholder="--Select--"
                onMenuOpen={() => handleSelectOpen('scpName')}
                onMenuClose={handleSelectClose}
                maxMenuHeight={160}
                isOptionDisabled={(option) => option.isDisabled}

              />


              <div className='icon-container'>
                {isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
              </div>
            </div>
            {scpNameError && <span className="error-message"></span>}
          </div>

          <div className="col-md-6 mb-3">
            <button type="button" className='add_btn ' onClick={addSCPToList} style={{ fontWeight: 'bold', width: "200px" }}>ADD</button>
          </div>

          {/* </div> */}
        </div>

        <div>
          {scpNamesList.length > 0 && (
            <table className='tableClass'>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>SCP Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {scpNamesList.map((scp, index) => (
                  <tr key={scp.id}>
                    <td>{index + 1}</td>
                    <td>{scp.name}</td>
                    <td>
                      <img
                        src={Icon5}
                        alt="suspendremovebg"
                        className=" delete_btn"
                        title='Remove'
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleOpenModal(scp.id, scp.name)}
                      />
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className="button-container">
        <button type="button" className="save_btn" onClick={handleEdit}>
          SAVE
        </button>
        <button type="button" className="reset_btn" onClick={handleReset}>
          RESET
        </button>
        <Link to={`/rmlist`}
          type="button" className="list_btn">LIST
        </Link>
      </div>
      {/* <Modal show={suspendConfirmationModal} backdrop="static" onHide={handleCloseModal} centered>
        <Modal.Header >
          <Modal.Title style={{ color: "#465a64", fontSize: '20px', fontWeight: "bold", textAlign: "center", width: "100%" }}>
            :: User Confirmation ::
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='suspend_para'>
            Are you sure you want to remove this SCP : {deletedSCPName}?
          </p>
        </Modal.Body>
        <div className='suspendbtn_container'>
          <button onClick={confirmRemoveSCP} className="yes_btn">
            Yes
          </button>
          <button onClick={handleCloseModal} className="no_btn">
            No
          </button>
        </div>
      </Modal> */}
      {suspendConfirmationModal && (
        <div className="popup_overlay" style={{
          backdropFilter: 'blur(3px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }}>
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>Are you sure you want to remove this SCP : {deletedSCPName} ?</h4>
            <div className="popup_btn_container">
              <button className="yes_btn " onClick={confirmRemoveSCP}>
                YES
              </button>
              <button className="no_btn " onClick={handleCloseModal}>
                NO
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RMEdit;